import { SysOrgPersonalizationNameType } from "../../U3148Service";

export interface OrganizationPersonalizationNameType {
  value: string;
  label: { fr: string; en: string } | string;
  scope: "admin" | "user";
}

/** Codes des types de personnalisation org_* + libellés pour l’UI (sélecteur et affichage). Scope en lecture seule côté API. */
const ALL_ORGANIZATION_PERSONALIZATION_NAME_TYPES: OrganizationPersonalizationNameType[] = [
  { value: SysOrgPersonalizationNameType.ADM_REGISTREFONCIERURL, label: { fr: "URL du registre foncier", en: "Land registry URL" }, scope: "admin" },
  { value: SysOrgPersonalizationNameType.ORG_REGISTREFONCIERUSERNAME, label: { fr: "Nom d'utilisateur du registre foncier", en: "Land registry username" }, scope: "user" },
  { value: SysOrgPersonalizationNameType.ORG_REGISTREFONCIERPASSWORD, label: { fr: "Mot de passe du registre foncier", en: "Land registry password" }, scope: "user" },
  { value: SysOrgPersonalizationNameType.ADM_AWSACCESSKEYID, label: { fr: "Clé d'accès AWS", en: "AWS access key ID" }, scope: "admin" },
  { value: SysOrgPersonalizationNameType.ADM_AWSSECRETACCESSKEY, label: { fr: "Clé secrète AWS", en: "AWS secret access key" }, scope: "admin" },
  { value: SysOrgPersonalizationNameType.ADM_AWSREGION, label: { fr: "Région AWS", en: "AWS region" }, scope: "admin" },
  { value: SysOrgPersonalizationNameType.ADM_AWSBUCKETRFLOT, label: { fr: "Bucket S3 – RF lot", en: "S3 bucket – RF lot" }, scope: "admin" },
  {
    value: SysOrgPersonalizationNameType.ADM_AWSBUCKETNAMERFLOTDETAIL,
    label: { fr: "Bucket S3 – RF lot detail", en: "S3 bucket – RF lot detail" },
    scope: "admin",
  },
  { value: SysOrgPersonalizationNameType.ADM_AWSBUCKETREPORT, label: { fr: "Nom du bucket AWS (rapports)", en: "AWS bucket name (reports)" }, scope: "admin" },
  {
    value: SysOrgPersonalizationNameType.ADM_AWSBUCKETASSETS,
    label: { fr: "Bucket AWS pour les assets (icônes/documents)", en: "AWS bucket for organization assets (icons/documents)" },
    scope: "admin",
  },
  { value: SysOrgPersonalizationNameType.ADM_AWSLAMBDAPDFTOJPEG, label: { fr: "Lambda AWS PDF vers JPEG", en: "AWS Lambda PDF to JPEG" }, scope: "admin" },
  { value: SysOrgPersonalizationNameType.ADM_AWSLAMBDAPDFTOJPEGDPI, label: { fr: "DPI Lambda AWS PDF vers JPEG", en: "AWS Lambda PDF to JPEG DPI" }, scope: "admin" },
  { value: SysOrgPersonalizationNameType.ADM_AWSLAMBDATEXTRACTTEXT, label: { fr: "Lambda AWS extraction de texte", en: "AWS Lambda extract text" }, scope: "admin" },
  { value: SysOrgPersonalizationNameType.ADM_INCLUDE_SUBPROJECT, label: { fr: "Inclure les sous-projets (U3121)", en: "Include sub-projects (U3121)" }, scope: "admin" },
  {
    value: SysOrgPersonalizationNameType.ADM_VACATION_NEGATIVE_THRESHOLD_HOURS,
    label: { fr: "Seuil vacances négatives (heures) (U3129/U3130)", en: "Negative vacation threshold (hours) (U3129/U3130)" },
    scope: "admin",
  },
  { value: SysOrgPersonalizationNameType.ORG_HOURLYMARKUP, label: { fr: "Majoration horaire par défaut (U3121)", en: "Default hourly markup (U3121)" }, scope: "user" },
  {
    value: SysOrgPersonalizationNameType.ORG_DEFAULT_RATE,
    label: { fr: "Taux de vente horaire par défaut (U3121)", en: "Default rate (U3121)" },
    scope: "user",
  },
  {
    value: SysOrgPersonalizationNameType.ORG_PROJECT_INACTIVITY_DAYS,
    label: { fr: "Jours d'inactivité projet (U3146)", en: "Project inactivity days (U3146)" },
    scope: "user",
  },
  {
    value: SysOrgPersonalizationNameType.ORG_TIMEZONE,
    label: { fr: "Fuseau horaire organisation (IANA)", en: "Organization time zone (IANA)" },
    scope: "user",
  },
  {
    value: SysOrgPersonalizationNameType.ORG_TIME_SESSION_ROUNDING_MINUTES,
    label: { fr: "Arrondi des sessions de temps (U3147)", en: "Time session rounding (U3147)" },
    scope: "user",
  },
  { value: SysOrgPersonalizationNameType.ORG_IMP_PR_PM, label: { fr: "Import projet – Chargé de projet par défaut (U3121)", en: "Project import – Default project manager (U3121)" }, scope: "user" },
  { value: SysOrgPersonalizationNameType.ORG_IMP_PR_SRVR, label: { fr: "Import projet – Arpenteur par défaut (U3121)", en: "Project import – Default surveyor (U3121)" }, scope: "user" },
  {
    value: SysOrgPersonalizationNameType.ORG_EMPLOYEUR_D_COMPANY_NUMBER,
    label: { fr: "Employeur D – Numéro de compagnie (sans lettres)", en: "Employeur D – Company number (no letters)" },
    scope: "user",
  },
  {
    value: SysOrgPersonalizationNameType.ORG_EMPLOYEUR_D_GAIN_MAPPING,
    label: { fr: "Employeur D – JSON codes de gains", en: "Employeur D – Gain codes JSON" },
    scope: "user",
  },
  {
    value: SysOrgPersonalizationNameType.ORG_EMPLOYEUR_D_WEEKLY_THRESHOLD,
    label: { fr: "Employeur D – Seuil surtemps hebdomadaire (heures)", en: "Employeur D – Weekly overtime threshold (hours)" },
    scope: "user",
  },
];

/** U3148 : uniquement les personnalisations org_* à portée usager (contrat BL-0268). */
export const ORGANIZATION_PERSONALIZATION_NAME_TYPES: OrganizationPersonalizationNameType[] =
  ALL_ORGANIZATION_PERSONALIZATION_NAME_TYPES.filter((entry) => entry.value.startsWith("org_") && entry.scope === "user");
